import type React from "react";
import { Button } from "@planta-v2/pds-ui/button";
import { DateUtils } from "@frontend/shared/presentation/utils/date.utils";
import { i18n } from "@frontend/i18n";

export interface InboundRequestActionsProps {
  readonly onAccept: () => Promise<void>;
  readonly onIgnore: () => Promise<void>;
  readonly requestDate: Date | null;
  readonly isLoading: boolean;
}

export function InboundRequestActions({
  onAccept,
  onIgnore,
  requestDate,
  isLoading,
}: InboundRequestActionsProps): React.JSX.Element {
  const handleAccept = (): void => {
    void onAccept();
  };

  const handleIgnore = (): void => {
    void onIgnore();
  };

  const locale = i18n.getLocale();
  const relativeDate =
    requestDate !== null
      ? DateUtils.formatRelativeDate(requestDate, locale)
      : null;

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex w-full items-center gap-3">
        <Button
          onClick={handleAccept}
          disabled={isLoading}
          data-testid="accept-button"
          className="flex-1"
          size="lg"
        >
          {isLoading
            ? i18n.t("user.directory.profile.cta.accepting")
            : i18n.t("user.directory.profile.cta.accept")}
        </Button>
        <Button
          type="button"
          variant="ghost"
          onClick={handleIgnore}
          disabled={isLoading}
          size="lg"
          className="shrink-0 text-muted-foreground"
        >
          {i18n.t("user.directory.profile.cta.ignore")}
        </Button>
      </div>
      {relativeDate !== null && (
        <p className="text-pds-2xs text-center text-muted-foreground">
          {i18n.t("user.directory.profile.cta.inboundHelp", {
            date: relativeDate,
          })}
        </p>
      )}
    </div>
  );
}
